"use client"
import React, {useState} from "react";
import styled from "styled-components";
import {IoIosEye, IoIosEyeOff} from "react-icons/io";
import {RiResetLeftFill} from "react-icons/ri";
import {IoSearch} from "react-icons/io5";
import {observer} from "mobx-react";

const Input = observer((
    {
        placeholder,
        id,
        inputType = "text",
        onChange,
            autoComplete,
        error,
        errorText,
        value,
        labelFor,
        labelName,
        reset,
        state,
        onBlur,
        onEyes,
        name,
        autoFocus,
        setTypeChange,
        search,
        onClick,
        onKeyDown,
        onFocus,
        disabled,
        readOnly,
        checked,
        mt,
        mr,
        mb,
        ml,
        dataset,
        maxlength,
        height,
        paymentMethod = undefined,
        className = "",
        brand = false,
        radius = "8px",
    inputMode = undefined,
            ref = null,
    }
) => {
    let [eye, setEye] = useState(false);
    return (
        <InputWrapper
            className={`${disabled ? "disabled" : ""} ${readOnly && (inputType === "radio" || inputType === "checkbox") ? "read-only" : ""} ${inputType === "text" ? "text" : ""} ${paymentMethod ? "pay-input" : ""} input-wrapper ${className}`}
            $typeName={inputType} $mt={mt} $mr={mr}
            $mb={mb} $ml={ml} $height={height} $radius={radius} $brand={brand}>
            <input
                id={id}
                placeholder={placeholder}
                type={inputType}
                inputMode={inputMode}
                onChange={onChange}
                name={name}
                onBlur={onBlur}
                onFocus={onFocus}
                ref={ref}
                onKeyDown={onKeyDown}
                disabled={disabled}
                readOnly={readOnly}
                autoComplete={autoComplete ?? "off"}
                autoFocus={!!autoFocus}
                maxLength={maxlength}
                {...(inputType === "checkbox"
                    ? {checked: !!checked}
                    : inputType === "radio"
                        ? {checked: !!checked, value}
                        : {value: value ?? ""})}
                data-id={dataset}
            />
            {inputType === "checkbox" && labelName && (
                <>
                    <label htmlFor={id} className="checkbox-label">
                        <span>{labelName}</span>
                    </label>
                </>
            )}
            {inputType !== "checkbox" && labelFor && labelName && (
                <label htmlFor={labelFor}>
                    <div>{labelName}</div>
                </label>
            )}

            {onEyes === "on" ?
                eye === false
                    ? <div className={"eyes"} onClick={() => {
                        setTypeChange("text")
                        setEye((prev) => !prev);
                    }}><IoIosEye/></div>
                    : <div className={"eyes"} onClick={() => {
                        setTypeChange("password")
                        setEye((prev) => !prev);
                    }}><IoIosEyeOff/></div>
                : null
            }
            {search && <div className={"ico-search"} onClick={onClick}><IoSearch/></div>}
            {reset &&
                <div
                    className="reset"
                    onClick={() => {
                        state[0]("")
                        state[1](false)
                    }}
                ><RiResetLeftFill/></div>
            }
            {/*{error ?? <p className={"warning-text"}>{errorText}</p>}*/}
        </InputWrapper>
    );
});

const InputWrapper = styled.div`
    width: ${({$typeName}) => ($typeName === "text" || $typeName === "password" ? "100%" : "auto")};
    height: ${({$typeName, $height, theme}) =>
            $height ?
                    // `${$height}` 
                    `${typeof $height === "string" ? $height : $height + "px"}`
                    : `${theme.SIZE.INPUT[$typeName].height}`};

    display: flex;
    align-items: center;
    gap: 10px;

    border-radius: ${({$radius}) => $radius};
    ${({$typeName, $brand, theme}) => ($typeName === "text" || $typeName === "password" || $typeName === "tel") &&
        `
        border: 2px solid ${$brand ? theme.COLORS.INPUT.brand.text.inActive : theme.COLORS.INPUT.text.inActive};
        padding: 0 14px;
        &:focus-within {
            border-color: ${$brand ? theme.COLORS.INPUT.brand.text.active : theme.COLORS.INPUT.text.active} !important;
        }
    `}
    &.read-only {
        pointer-events: none;
    }

    input:-webkit-autofill {
        -webkit-box-shadow: 0 0 0 1000px ${({theme}) => theme.COLORS.INPUT.text.bg || "#fff"} inset !important;
        -webkit-text-fill-color: ${({theme}) => theme.COLORS.INPUT.text.font.default} !important;
        transition: background-color 9999s ease-in-out 0s;
    }
        
    input {
        position: relative;
        flex: 1; /* wrapper 안에서 꽉 차게 */
        border: none;
        outline: none;
        background: transparent;
        height: 100%;
        color: ${({theme, $brand}) => `${$brand ? theme.COLORS.INPUT.brand.text.inActive : theme.COLORS.INPUT.text.font.default}`};
        font-size: ${({theme, $typeName}) => theme.SIZE.INPUT[$typeName].font};
        font-weight: ${({theme, $typeName}) => theme.SIZE.INPUT[$typeName].weight};
        width: 100%;


        &::placeholder {
            color: ${({theme}) => theme.COLORS.INPUT.text.placeholder};
        }
    }

    label {
        font-size: ${({theme, $typeName}) => theme.SIZE.INPUT[$typeName].font};
        font-weight: ${({theme, $typeName}) => theme.SIZE.INPUT[$typeName].weight};
        color: ${({theme}) => theme.COLORS.INPUT.box.font.default};
        cursor: pointer;
    }

    /* 체크박스 커스텀 */
    input[type="checkbox"] {
        appearance: none;
        -webkit-appearance: none;
        -moz-appearance: none;
        width: ${({theme}) => theme.SIZE.INPUT.checkbox.width};
        height: ${({theme}) => theme.SIZE.INPUT.checkbox.height};
        border: 1px solid ${({theme}) => theme.COLORS.INPUT.box.inActive};
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        padding: 0;
        margin: 0;
        background-color: #fff;
        flex-shrink: 0;
    }

    input[type="checkbox"]:checked {
        border-color: ${({theme}) => theme.COLORS.INPUT.box.active};
    }

    input[type="checkbox"]:checked::after {
        content: "";
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%) rotate(45deg);
        width: 5px;
        height: 10px;
        border: solid ${({theme}) => theme.COLORS.INPUT.box.active};
        border-width: 0 2px 2px 0;
    }


    /* 라디오 버튼 커스텀 */

    input[type="radio"] {
        flex-shrink: 0;
        appearance: none;
        -webkit-appearance: none;
        -moz-appearance: none;
        width: ${({theme}) => theme.SIZE.INPUT.radio.width};
        height: ${({theme}) => theme.SIZE.INPUT.radio.height};
        border: 1px solid ${({theme}) => theme.COLORS.INPUT.box.inActive};
        border-radius: 50%;
        background-color: ${({theme}) => theme.COLORS.INPUT.box.active}
        cursor: pointer;
        position: relative;
        padding: 0;
        margin: 0;
    }

    input[type="radio"]:checked {
        border-color: ${({theme}) => theme.COLORS.INPUT.box.active};
    }

    input[type="radio"]:checked::after {
        content: "";
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 8px;
        height: 8px;
        background-color: ${({theme}) => theme.COLORS.INPUT.box.active};
        border-radius: 50%;
    }

    /* 체크박스/라디오 공통 래퍼 */

    .checkbox-label,
    .radio-label {
        display: flex;
        align-items: center;
        gap: 6px; /* 라벨과 인풋 사이 거리 */
    }

    input[type="checkbox"],
    input[type="radio"] {
        flex: 0 0 ${({theme}) => theme.SIZE.INPUT.checkbox.width}; /* shrink/grow 둘 다 0 */
    }

    &.disabled {
        &.text {
            //pointer-events: none;
            border-color: ${({theme}) => theme.COLORS.INPUT.text.disabled.solid};
            background-color: ${({theme}) => theme.COLORS.INPUT.text.disabled.bg};
            color: ${({theme}) => theme.COLORS.INPUT.text.font.disabled};
        }

        input {
            border-color: ${({theme}) => theme.COLORS.INPUT.text.disabled.solid};
            background-color: ${({theme}) => theme.COLORS.INPUT.text.disabled.bg};
            color: ${({theme}) => theme.COLORS.INPUT.text.font.disabled};
        }

        label {
            pointer-events: none;
            color: ${({theme}) => theme.COLORS.INPUT.box.font.disabled};
        }

        input[type="checkbox"], input[type="radio"] {
            border-color: ${({theme}) => theme.COLORS.INPUT.box.disabled.solid};
            background-color: ${({theme}) => theme.COLORS.INPUT.box.disabled.bg};

            &::after {
                border-color: ${({theme}) => theme.COLORS.INPUT.box.disabled.solid};
            }
        }
    }
`;


export default Input;
